import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  StruggleMark,
  WalkerFigure,
} from './shared';

export default function WalkingTiredIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.struggle;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="Yürüyüş zorlanıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={46} endY={30} accent={accent} />
      <WalkerFigure cx={44} cy={24} posture="tired" primary={primaryColor} />
      <StruggleMark x={58} y={14} />
    </IllustrationSvg>
  );
}
